import React from "react";
import { useCombinedStore } from "../store";
import * as AlfredoStyles from "../styles/components/Report";

const LastOptions: React.FC = () => {
  return (
    <AlfredoStyles.LastOptionsContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>query_stats</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Resumo das Informações</AlfredoStyles.Title>
      </AlfredoStyles.Card>
    </AlfredoStyles.LastOptionsContainer>
  );
};

export default LastOptions;
